<script setup>

import {onMounted, ref} from 'vue';
import Button from "@/components/forms/Button.vue";
import {formatDate, getAppDomain, showSuccessMessage} from '../../helper';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import {refreshLoggedUser} from '@/services/AuthService';
import ClientService from "@/services/ClientService";
import {useDataTable} from "@/utils/datatableHelper";
import ModalDialog from "@/components/modals/ModalDialog.vue";
import CreateUpdateContractModal from "@/components/modals/CreateUpdateContractModal.vue";
import B from "../../../assets/B.svg";

const props = defineProps({
  entityId: {
    type: Number,
    default: null,
  },
});

import {useI18n} from 'vue-i18n'

const {t} = useI18n()

const appDomain = getAppDomain();

const contracts = ref([]);

const isLoading = ref(false);

const columns = ref([
  {
    label: t('contractsIndexTableComponent.contract_number'),
    field: 'contract_number',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('contractsIndexTableComponent.contract_type'),
    field: 'contract_type.name'
  },
  {
    label: '',
    field: 'action',
    sortable: false,
  },
]);

onMounted(async () => {
      getContracts();
      emitter.on('contractSaved', () => {
        getContracts();
      });
      emitter.on('contractDeleted', (contractId) => {
        let contractIndex = contracts.value.findIndex(contract => contract.id === contractId);
        contracts.value.splice(contractIndex, 1);
      })
    }
);

function getContracts() {
  isLoading.value = true;
  ClientService.getClientContractsv2(props.entityId, true)
      .then((response) => {
        contracts.value = response;
        isLoading.value = false;
      })
      .catch((error) => {
        console.log(error);
      });
}

function updateContract(contract) {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateContractModal, {clientId: props.entityId, contract: contract});
  reveal();
  onConfirm((contract) => {
    ClientService.saveContract(props.entityId, contract).then(response => {
      let contractIndex = contracts.value.findIndex(contract => contract.id === response.contract.id);
      contracts.value[contractIndex] = response.contract;
      showSuccessMessage(response.message);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div>
    <div class="table-container">
      <vue-good-table
          :columns="columns"
          :rows="contracts"
          :pagination-options="{
                  enabled: true,
                rowsPerPageLabel: t('contractsIndexTableComponent.entriesPerPage'),
                nextLabel: t('contractsIndexTableComponent.next'),
                prevLabel: t('contractsIndexTableComponent.previous'),
                ofLabel: 'z',
                }">
        <template #table-row="props">
              <span v-if="props.column.field == 'contract_number'">
                <span :class="props.row.meta?.is_trashed ? 'line-through' : ''">{{ props.row.contract_number }}</span>
                <div v-if="props.row.meta.is_trashed"><span class="badge badge-danger">Smazáno</span></div>
              </span>
                            <span v-if="props.column.field == 'action'">
                                <span style="font-weight: bold; float: right">
<!--                                    <router-link :to="{ name: 'ClientDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-link"><i class="mdi mdi-eye"/></button></router-link>
                                -->
                                  <button v-if="props.row.external_id && appDomain === 'SK/CZ'" type="button" class="btn btn-outline-primary-2 bg-white btn-b me-2"><a :href="'https://www.hcis.cz/?page=investice_bidli-investicni_produkty-edit&id=' + props.row.external_id" target="_blank"><img :src="B" /></a></button>
                                <button type="button" class="btn btn-primary btn-normal" @click="updateContract(props.row)"><i class="mdi mdi-pencil"/></button>
                                </span>
                            </span>
        </template>
        <template v-slot:emptystate v-if="!isLoading">
          <div class="text-center">
            {{ t('contractsIndexTableComponent.no_records_found') }}
          </div>
        </template>
        <template v-slot:emptystate v-if="isLoading">
          <div class="text-center">
            {{ t('contractsIndexTableComponent.loading') }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
